export const formatAmount = (amount?: number) => {
  if (typeof amount !== 'undefined') {
    return amount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } else {
    return 0; // or any default value you prefer
  }
};
